<div class="ai-assistant-container">
  <div class="ai-assistant-content">
    <div class="info-container">
      <div class="avatar-container">
        @if (avatarSrc()) {
          <glxy-avatar [src]="avatarSrc()"></glxy-avatar>
        } @else {
          <glxy-avatar [svgIcon]="defaultAvatarIcon"></glxy-avatar>
        }
        <div class="text-container">
          <p class="title">{{ aiAssistant()?.assistant?.name }}</p>
          @if (aiAssistant()?.subtitleKey) {
            <p class="subtitle">{{ aiAssistant()?.subtitleKey ?? '' | translate }}</p>
          }
        </div>
      </div>
      @if (showSelectAssistantButton()) {
        <button mat-button color="primary" (click)="openSelectAssistantDialog()">
          {{ 'AI_ASSISTANT.ASSISTANT_REFERENCE_CARD.SELECT_ASSISTANT' | translate }}
        </button>
      }
      @if (aiAssistantConfigUrl()) {
        <a mat-stroked-button class="configure-button" [routerLink]="[aiAssistantConfigUrl()]">
          {{ 'AI_ASSISTANT.SHARED.CONFIGURE' | translate }}
        </a>
      }
    </div>
  </div>
</div>
